var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"element",staticClass:"candidate-icon relative point",class:{
    'candidate-draggable': _vm.candidateDraggable,
    'candidate-icon-small': _vm.small
  },style:({
    color:
      !_vm.showPosition || _vm.position > 0
        ? 'var(--ui-interaction-dark)'
        : 'var(--ui-interaction-light)'
  }),on:{"mousedown":_vm.onMouseDown,"touchstart":_vm.onTouchDown,"touchmove":_vm.onPointerMove,"touchend":_vm.onPointerUp,"touchcancel":_vm.onPointerUp,"click":_vm.onClick}},[(!_vm.dragMode || _vm.cloneOnDrag)?_c('div',{staticClass:"candidate-background absolute top-0 left-0 w-full h-full pointer-events-none",class:{
      shadow: _vm.candidateDraggable,
      'bg-gray-100': _vm.teamPlaces > 0,
      'bg-white': (_vm.teamPlaces === 0 && _vm.candidateDraggable) || _vm.opaque
      /*'bg-gray-300': dragMode*/
    }}):_vm._e(),_c('div',{staticClass:"absolute top-0 left-0 w-full h-full",style:({ visibility: _vm.dragMode && !_vm.cloneOnDrag ? 'hidden' : null })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPosition && _vm.position > 0),expression:"showPosition && position > 0"}],staticClass:"text-chplus-candidate-name absolute top-0",staticStyle:{"left":"0.2rem","color":"var(--interaction-dark)"}},[_vm._v(" "+_vm._s(_vm.position)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatchPercent),expression:"showMatchPercent"}],class:{
        'text-color-regular':
          _vm.candidate.matchType === _vm.MatchType.Like ||
          _vm.candidate.matchType === _vm.MatchType.Love,
        'text-interaction-dark':
          _vm.candidate.matchType !== _vm.MatchType.Like &&
          _vm.candidate.matchType !== _vm.MatchType.Love,
        'text-chplus-candidate-match-s': !_vm.small,
        'text-chplus-s': _vm.small
      }},[_vm._v(" "+_vm._s(_vm._f("decimal")(Math.round(_vm.candidate.matchPercent),"0"))),_c('span',{class:{
          'text-chplus-s': !_vm.small,
          'text-chplus-xs': _vm.small
        }},[_vm._v("%")])]),_c('candidate-portrait',{attrs:{"candidate":_vm.candidate,"position":_vm.position,"show-position":_vm.showPosition,"small":_vm.small,"team-places":_vm.teamPlaces}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showName),expression:"showName"}],staticClass:"candidate-name text-center leading-none max-w-full overflow-hidden",class:{
        'text-color-regular':
          _vm.candidate.matchType === _vm.MatchType.Like ||
          _vm.candidate.matchType === _vm.MatchType.Love,
        'text-interaction-dark':
          _vm.candidate.matchType !== _vm.MatchType.Like &&
          _vm.candidate.matchType !== _vm.MatchType.Love,
        'text-chplus-xs': _vm.small,
        'text-chplus-s': !_vm.small,
        'break-word': !_vm.truncateName,
        'whitespace-no-wrap': _vm.truncateName,
        'overflow-hidden': _vm.truncateName,
        'small-name': _vm.small
      },staticStyle:{"margin-top":"0.15rem"},style:({
        'text-overflow': 'ellipsis'
      })},[_vm._v(" "+_vm._s(_vm.candidate.lastName)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }